import _isNumber from 'lodash/isNumber';
import React, { Component, Fragment } from 'react';

import { getPointerPosition } from 'utilities/dom';

import './styles.less';

// this component was heavily inspired by the video-react Slider component
// https://github.com/video-react/video-react
class Slider extends Component {
  state = { currentWidth: 0 };

  constructor(props) {
    super(props);

    this.calculateDistance = this.calculateDistance.bind(this);
    this.getProgress = this.getProgress.bind(this);
    this.renderChildren = this.renderChildren.bind(this);

    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
  }

  getProgress() {
    const { getPercent } = this.props;

    if (!getPercent) {
      return 0;
    }

    let progress = getPercent();

    // Protect against no duration and other division issues
    if (!_isNumber(progress) || progress < 0) {
      progress = 0;
    }

    return progress;
  }

  handleMouseDown(e) {
    document.addEventListener('mousemove', this.handleMouseMove, true);
    document.addEventListener('mouseup', this.handleMouseUp, true);
    document.addEventListener('touchmove', this.handleMouseMove, true);
    document.addEventListener('touchend', this.handleMouseUp, true);

    this.handleMouseMove(e);

    if (this.props.onMouseDown) {
      this.props.onMouseDown(e);
    }
  }

  handleMouseMove(e) {
    this.slider?.focus();

    if (this.props.onMouseMove) {
      this.props.onMouseMove(e);
    }
  }

  handleMouseUp(e) {
    document.removeEventListener('mousemove', this.handleMouseMove, true);
    document.removeEventListener('mouseup', this.handleMouseUp, true);
    document.removeEventListener('touchmove', this.handleMouseMove, true);
    document.removeEventListener('touchend', this.handleMouseUp, true);

    this.slider?.blur();

    if (this.props.onMouseUp) {
      this.props.onMouseUp(e);
    }
  }

  handleFocus(e) {
    if (this.props.onFocus) {
      this.props.onFocus(e);
    }
  }

  handleBlur(e) {
    if (this.props.onBlur) {
      this.props.onBlur(e);
    }
  }

  handleClick(e) {
    e.preventDefault();

    if (this.props.onClick) {
      this.props.onClick(e);
    }
  }

  calculateDistance(e) {
    const { x, y } = getPointerPosition(this.slider, e);

    return this.props.vertical ? y : x;
  }

  renderChildren() {
    const progress = this.getProgress();
    const percentage = `${(progress * 100).toFixed(2)}%`;
    const { slider } = this;

    return React.Children.map(this.props.children, child =>
      child != null
        ? React.cloneElement(child, {
            progress,
            percentage,
            slider,
            sliderWidth: this.state.currentWidth,
          })
        : null
    );
  }

  componentDidMount() {
    const { increasedVerticalClickArea, sliderId } = this.props;

    // require an id if we're increasing the vertical interaction area
    // to apply styles to only 1 slider
    if (increasedVerticalClickArea && !sliderId) {
      throw new Error('slider has increased vertical area without unique id');
    }
  }
  componentDidUpdate() {
    const stateWidth = this.state.currentWidth;
    const clientWidth = this.slider && this.slider.clientWidth;

    // We do this to ensure we always get the correct clientWidth
    // post render of this component
    // https://www.loom.com/share/e9a43a836e5c427fba9762ee89d2c2c4
    if (stateWidth !== clientWidth) {
      this.setState({
        currentWidth: clientWidth,
      });

      this.props.onClientWidthUpdate &&
        this.props.onClientWidthUpdate(clientWidth);
    }
  }

  render() {
    const { vertical = false, label = '', valuenow = '' } = this.props;

    return (
      <Fragment>
        <div
          tabIndex="0"
          ref={slider => (this.slider = slider)}
          className={`slider ${vertical ? 'vertical' : 'horizontal'}`}
          onMouseDown={this.handleMouseDown}
          onTouchStart={this.handleMouseDown}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          onClick={this.handleClick}
          aria-label={label}
          aria-valuenow={valuenow}
          aria-valuemin={0}
          aria-valuemax={100}
        >
          {this.renderChildren()}
        </div>
      </Fragment>
    );
  }
}

export default Slider;
